import Joi from '@hapi/joi'

export const MobilemenuCollectionCatagoryMappingSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collection Category").messages({
        "any.invalid": `Collection category cannot have invalid characters`,
        "any.required": `Collection category required`
    })
}

export const MobilemenuCollectionCatagoryMappingEditSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    mobileMenuID: Joi.number().invalid(0).required().label("Mobile Menu").messages({
        "any.invalid": `Mobile Menu cannot have invalid characters`,
        "any.required": `Mobile Menu required`
    }),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collectioncatagory").messages({
        "string.empty": `Collectioncatagory required`,
        "string.pattern.base": `Please enter valid Collectioncatagory`,
    }),
    primaryMenuVerificationTypeID: Joi.number().invalid(0).required().label("Primary Menu Verification").messages({
        "string.empty": `Primary Menu Verification required`,
        "string.pattern.base": `Please enter valid Primary Menu Verification`,
    }),
    secondaryMenuVerificationTypeID: Joi.number().required().label("Secondary Menu Verification Type").messages({
        "string.empty": `Secondary Menu Verification Type required`,
        "string.pattern.base": `Please enter valid Secondary Menu Verification Type`,
    }),
    isActive: Joi.boolean().label("Active"),
    collectionTagEnabled: Joi.boolean().label("Active")
}